module.exports = __webpack_public_path__ + "assets/icons/ic_calendar_24px.svg";